import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type Decision, type DecisionActivity } from '../../api/decision';

export function DecisionTimelinePage() {
  const [decisions, setDecisions] = useState<Decision[]>([]);
  const [activity, setActivity] = useState<DecisionActivity[]>([]);

  useEffect(() => {
    void decisionApi.listDecisions((getWorkspaceId() ?? '')).then(setDecisions);
    void decisionApi.listActivity().then(setActivity);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Decision Timeline</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Audit trail of decisions, approvals and autonomous executions.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 space-y-3">
        {decisions.map((d) => (
          <div key={d.id} className="rounded-xl border p-4 dark:border-slate-700">
            <p className="font-medium">{d.title}</p>
            <p className="text-xs text-slate-500">{d.domain} · {d.status} · score {d.score.toFixed(0)}</p>
          </div>
        ))}
        {activity.map((a) => (
          <div key={a.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">
            <span className="text-xs text-slate-500">{new Date(a.created_at).toLocaleString()}</span>
            <span className="ml-2">{a.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
